import { toBasicFormData } from '~/src/helpers/formatter';
import { captureException } from '@sentry/node';
import callRequest from '@stelecom/ui-react/components/requests/callRequestIntegration';

export interface IOmsResponse {
    status: number,
    message: string | undefined | null
}

export async function requestByCallByOms(phone: string, cityId: number | string): Promise<IOmsResponse> {
    try {
        const res = await callRequest(process.env.ENVIROMENT === 'production' ? 'stelecom' : 'rinet').post(
            '/user/request-by-call-by-oms',
            toBasicFormData({
            phone,
            cityId,
        })
);
      return res.data ? { status: 1, message: 'Заявка успешно создана.' } : { status: 0, message: null };
    } catch (err) {
        captureException(err);
        return {
            status: 0,
            message: err?.response?.data?.message,
        };
    }

}
